import { Redirect, useHistory, useLocation } from "react-router-dom";
import { useAppSelector } from "../redux/typedHooks";
import { useEffect, useState } from "react";
import { showToast } from "../utils/toast";
import { getUserType } from "../utils/getUserType";
import AccountRevokedScreen from "../components/AccountRevoked/AccountRevokedScreen";
import BaseLoading from "../components/Loader/BaseLoading";
import React from "react";

const CheckAccess = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);

  const [isValidated, setIsValidated] = useState(false);
  const [isAgeProofed, setIsAgeProofed] = useState(false);
  const [isRevoked, setIsRevoked] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const user = useAppSelector<{
    firstName: string;
    lastName: string;
    email: string;
    DOB: string;
    isOnboarding: boolean;
    emailVerified?: boolean;
    phoneVerified?: boolean;
    profileCompletion?: boolean;
    validated?: boolean;
    ageProofed: boolean;
    revoke: boolean;
    isAdmin: boolean;
    userType: any;
  } | null>(state => state.user.currentUser);

  useEffect(() => {
    if (!user) {
      // Перевіряємо, чи користувач раніше реєструвався/входив
      const hasRegisteredOrLoggedIn = localStorage.getItem("hasRegisteredOrLoggedIn");
      if (hasRegisteredOrLoggedIn === "true") {
        history.push("/login");
      } else {
        history.push("/register");
      }
      return;
    }

    const rawUserType = getUserType(user);
    const userTypeTitle = (typeof rawUserType === "string" ? rawUserType : rawUserType?.title)?.toLowerCase();
    const userTypeId = typeof rawUserType === "object" ? ((rawUserType as any)?._id || (rawUserType as any)?.id) : rawUserType;

    const isCreator =
      userTypeTitle === "creator" ||
      userTypeTitle === "model" ||
      userTypeId === "6800a63485ec077c7c266c25" ||
      userTypeTitle === "6800a63485ec077c7c266c25" ||
      (user as any)?.contentProviderAgreementAccepted === true;

    const isMemberOrViewer =
      userTypeTitle === "viewer" ||
      userTypeTitle === "member" ||
      userTypeId === "6800a68085ec077c7c266c27" ||
      userTypeTitle === "6800a68085ec077c7c266c27";

    const isMemberComplete =
      (user.emailVerified === true || user.validated === true) &&
      (user.phoneVerified === true || Boolean((user as any).phoneNumber)) &&
      (user.profileCompletion === true || Boolean((user as any).aboutMe) || user.isOnboarding === true || Boolean((user as any).currentSubscriptionTier));

    const isCreatorComplete =
      (user.emailVerified === true || user.validated === true) &&
      (user.phoneVerified === true || Boolean((user as any).phoneNumber)) &&
      (user.profileCompletion === true || Boolean((user as any).aboutMe) || user.isOnboarding === true);

    const computedValidated = isMemberOrViewer ? isMemberComplete : isCreator ? isCreatorComplete : user.isOnboarding;
    const computedAgeProofed = isMemberOrViewer ? isMemberComplete : isCreator ? isCreatorComplete : user.ageProofed;
    const computedRevoked = (isMemberOrViewer || isCreator) ? false : user.revoke;

    console.log("[CheckAccess] Evaluated access state:", {
      pathname: location.pathname,
      isCreator,
      isMemberOrViewer,
      isMemberComplete,
      isCreatorComplete,
      computedValidated,
      computedAgeProofed,
      computedRevoked,
      isAdmin: user?.isAdmin,
      willRedirect: !computedValidated && !user?.isAdmin && !computedAgeProofed && location.pathname !== "/member-onboarding-step" && location.pathname !== "/apply-as-creator" && location.pathname !== "/choose-user-type"
    });

    setIsValidated(computedValidated);
    setIsAgeProofed(computedAgeProofed);
    setIsRevoked(computedRevoked);

    setIsLoading(false);
  }, [user, history]);

  if (isLoading) {
    return <BaseLoading />;
  }

  if (
    !isValidated &&
    !user?.isAdmin &&
    !isAgeProofed &&
    location.pathname !== "/member-onboarding-step" &&
    location.pathname !== "/apply-as-creator" &&
    location.pathname !== "/choose-user-type"
  ) {
    const rawUserType = getUserType(user);
    const userTypeTitle = (typeof rawUserType === "string" ? rawUserType : rawUserType?.title)?.toLowerCase();
    const userTypeId = typeof rawUserType === "object" ? ((rawUserType as any)?._id || (rawUserType as any)?.id) : rawUserType;
    const isCreator =
      userTypeTitle === "creator" ||
      userTypeTitle === "model" ||
      userTypeId === "6800a63485ec077c7c266c25" ||
      userTypeTitle === "6800a63485ec077c7c266c25" ||
      (user as any)?.contentProviderAgreementAccepted === true;

    const isEmailDone = user?.emailVerified === true || user?.validated === true;
    const isPhoneDone = user?.phoneVerified === true || Boolean((user as any)?.phoneNumber);
    const isProfileDone = user?.profileCompletion === true || Boolean((user as any)?.aboutMe);
    const step = !isEmailDone ? 1 : !isPhoneDone ? 2 : !isProfileDone ? 3 : 6;

    if (isCreator) {
      console.warn(`[CheckAccess] Creator access check failed -> Redirecting to /apply-as-creator?step=${step}`);
      return <Redirect to={`/apply-as-creator?step=${step}`} />;
    }
    console.warn(`[CheckAccess] Member access check failed -> Redirecting to /member-onboarding-step?step=${step}`);
    return <Redirect to={`/member-onboarding-step?step=${step}`} />;
  }

  if (isRevoked) {
    return <AccountRevokedScreen />;
  }

  return <>{children}</>;
};

export default CheckAccess;
